document.addEventListener("DOMContentLoaded", function () {
    const mutedIcon = document.querySelector("#igReelsMutedIcon svg");
    const volumeIcon = document.querySelector("#igReelsVolumeIcon svg");

    const pauseIcon = document.querySelector("#igReelsPauseIcon svg");
    const resumeIcon = document.querySelector("#igReelsResumeIcon svg");

    document.querySelectorAll(".instagram-reel-item").forEach(item => {
        const video = item.querySelector("video");

        // volume controls
        const volumeControl = item.querySelector("#instagramReelsVideoOverlayVolume");
        volumeControl.appendChild(mutedIcon.cloneNode(true));
        volumeControl.addEventListener("click", () => {
            if (video.muted) {
                video.muted = false;
                const oldChild = volumeControl.querySelector("svg");
                volumeControl.replaceChild(volumeIcon.cloneNode(true), oldChild);
            }
            else {
                video.muted = true;
                const oldChild = volumeControl.querySelector("svg");
                volumeControl.replaceChild(mutedIcon.cloneNode(true), oldChild);
            }
        });

        // playback control
        const playbackControl = item.querySelector("#instagramReelsVideoOverlayPlayback");
        playbackControl.appendChild(resumeIcon.cloneNode(true));
        playbackControl.addEventListener("click", () => {
            if (video.paused) {
                video.play();
                const oldChild = playbackControl.querySelector("svg");
                playbackControl.replaceChild(pauseIcon.cloneNode(true), oldChild);
            }
            else {
                video.pause();
                const oldChild = playbackControl.querySelector("svg");
                playbackControl.replaceChild(resumeIcon.cloneNode(true), oldChild);
            }
        });
    });
});

function scrollLeft() {
    document.getElementById('instagram-reels-slider').scrollLeft -= emToPx(25);
}

function scrollRight() {
    document.getElementById('instagram-reels-slider').scrollLeft += emToPx(25);
}

function emToPx(em) {
    return em * parseFloat(getComputedStyle(document.getElementById('instagram-reels-slider')).fontSize);
}

document.addEventListener('DOMContentLoaded', function () {
    const prevBtn = document.querySelector('.ig-prev-btn');
    const nextBtn = document.querySelector('.ig-next-btn');

    const widgetWidth = document.querySelector(".instagram-reels-slider-track").clientWidth;
    const windowWidth = window.innerWidth;
    
    if (widgetWidth <= windowWidth) {
        prevBtn.classList.add("hidden");
        nextBtn.classList.add("hidden");

        document.querySelector("#instagram-reels-slider").style.justifyContent = "center";

        return;
    }

    prevBtn.addEventListener('click', () => scrollLeft());
    nextBtn.addEventListener('click', () => scrollRight());
});